import { render, staticRenderFns } from "./dot-pattern-background.vue?vue&type=template&id=6a08a182&scoped=true&"
import script from "./dot-pattern-background.vue?vue&type=script&lang=js&"
export * from "./dot-pattern-background.vue?vue&type=script&lang=js&"
import style0 from "./dot-pattern-background.vue?vue&type=style&index=0&id=6a08a182&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08a182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a08a182')) {
      api.createRecord('6a08a182', component.options)
    } else {
      api.reload('6a08a182', component.options)
    }
    module.hot.accept("./dot-pattern-background.vue?vue&type=template&id=6a08a182&scoped=true&", function () {
      api.rerender('6a08a182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dot-pattern-background.vue"
export default component.exports